<!--
* @description  参数1
* @fileName  ByTableTh
* @author userName
* @date 2021-11-17 11:51:26
!-->
<template>
  <!-- <div id="ByTableTh" class="ByTableTh"> -->
    <th v-if="tableTitleData.length>0" class="table-title pd_tb_12 fz_000" :style="{width:tableTitleData[tableTdIndex].width ? tableTitleData[tableTdIndex].width : '100px'}"  :class="{ bor_ddd_03: tableTdIndex !== 0 ,colBlue:tableTitleData[tableTdIndex]?tableTitleData[tableTdIndex].isVolume:false }">
      <div class="pd_lr_5">
        <span>{{tableTitleData[tableTdIndex] ? tableTitleData[tableTdIndex].name : ''}}</span>
        <slot></slot>
      </div>
    </th>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    // 父辈向子辈传参
     tableTitleData: {
      type: [Array],
      default: ()=>[],
    },
    tableTdIndex: {
      type: [Number],
      default: 0,
    },
  },
  name: "ByTableTh",
  data() {
    return {
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
.fff {
  background: #fff;
}
.pd_tb_12 {
  padding: 12px 0;
}
.pd_lr_5 {
  padding: 0 5px;
}
.by-table-box {
  background: #f9f9f9;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
}
.mar_T_10 {
  margin-top: 10px;
}
.bor_ddd_03{
  border-left:1px solid rgba($color: #DDDDDD, $alpha: 0.3);
}
.table-title {
  // overflow: hidden;
  box-sizing: border-box;
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/common/components/ByTableTh.vue